((AffiliateForm, $) => {
  'use strict';

  const $dom = {};
  const $form = $('form#affiliate-signup-form');
  const _SELECTORS = {
    SUBMIT_BUTTON:          'data-submit-button',
    SUCCESS_MESSAGE:        'data-success-message',
    ERROR_MESSAGE:          'data-error-message'
  }
  
  const cacheDom = () => {
    $dom.submitButton = $(`[${_SELECTORS.SUBMIT_BUTTON}]`)
    $dom.successMessage = $(`[${_SELECTORS.SUCCESS_MESSAGE}]`)
    $dom.errorMessage = $(`[${_SELECTORS.ERROR_MESSAGE}]`)
  }

  const validateForm = ($form) => {
  	let valid = true;
  	let $required = $($form).find('input[required]');

  	$required.each((index, field) => {
  		if($(field).val() === ''){
  			valid = false;
  		}
  	})

  	return valid; 
  }

  const _hideButton = () => {
    return $dom.submitButton.addClass('is-hidden');
  }

  const _showSuccessMessage = () => {
    return $dom.successMessage.addClass('is-visible');
  }

  const _showErrorMessage = () => {
    return $dom.errorMessage.addClass('is-visible');
  }

  const bindUIActions = () => {
    $form.on('submit', function(e) {
      e.preventDefault();
      const data = $form.serialize();
      const baseURL = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSd7no4kPyRH5Bw4eH9Gko3I0Ugrx9OBj4usXqhwJw4j-OON7w/formResponse?';

      // submitRef = Value of "fbzx" input field in google form (<input type="hidden" name="fbzx" value="2762055228570747669">)
      const submitRef = '&submit=2762055228570747669';
      const submitURL = (baseURL + submitRef);

      if (validateForm($form) === true) {
       	$.ajax({
	        url: submitURL,
          data: data,
          crossDomain: true,
	        type: "POST",
          dataType: "xml",
	        statusCode: {
	          200: console.log('200')
	        }
        })
        .always(() => {
          _hideButton();
          _showSuccessMessage();
        })
      }else{
      	window.alert('Please fill out form before submitting');
      }
  	})
  };

  AffiliateForm.init = () => {
    cacheDom();
    bindUIActions();
  }

})(window.AffiliateForm = window.AffiliateForm || {}, jQuery);